module.exports = __webpack_public_path__ + "static/columnResizing-5594a54a5c4148c54e1eb6a43d393bc9.gif";